import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IFinanceMonthChangeStatusPayload } from '@modules/finance/submodules/month-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  FINANCE_LIST_QUERY_KEY,
  FINANCE_PERMISSIONS,
} from '@modules/finance/constants';
import { useToastStore } from '@modules/toast/store';
import { isString } from '@utils/guards';

import {
  FINANCE_MONTH_APPROVE_MUTATION_KEY,
  FINANCE_MONTH_APPROVE_URL,
  FINANCE_MONTH_LIST_QUERY_KEY,
} from '../constants';

export default function useApproveFinanceMonthMutation(): IContextMutationResult<
  void,
  Error,
  IFinanceMonthChangeStatusPayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IFinanceMonthChangeStatusPayload>({
    mutationKey: [FINANCE_MONTH_APPROVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      FINANCE_MONTH_APPROVE_URL,
      payload,
      { permission: FINANCE_PERMISSIONS.CHANGE_STATUS },
    ),
    onSuccess({ queryClient }) {
      void queryClient.invalidateQueries({
        predicate: (query) => isString(query.queryKey[0]) && [
          FINANCE_MONTH_LIST_QUERY_KEY,
          FINANCE_LIST_QUERY_KEY,
        ].includes(query.queryKey[0]),
      });
      displayPresetToast('success');
    },
  });
}
